import React from 'react';

import { useDebriefDispatch, useDebriefSelector } from 'ff/debrief/hooks';
import {
    selectFilterEndDate,
    selectFilterStartDate,
    selectFuzzySearchTerm,
    setFilterEndDate,
    setFilterStartDate,
    setFuzzySearchTerm,
    setToastMessage,
    setToastState,
} from 'ff/debrief/features/AppSlice';

export const useDebriefApp = () => {
    const dispatch = useDebriefDispatch();

    const isShareApp = useDebriefSelector(s => s.appSlice.isShareApp);
    const isToastOpen = useDebriefSelector(s => s.appSlice.toast.isOpen);

    const startDate = useDebriefSelector(selectFilterStartDate);
    const endDate = useDebriefSelector(selectFilterEndDate);

    const fuzzySearchTerm = useDebriefSelector(selectFuzzySearchTerm);

    const openToast = (message: string) => {
        dispatch(setToastState(true));
        dispatch(setToastMessage(message));
    };

    const closeToast = () => {
        dispatch(setToastState(false));
        dispatch(setToastMessage(''));
    };

    const setStartDate = (newStartDate: number) => {
        dispatch(setFilterStartDate(newStartDate));
    };

    const setEndDate = (newEndDate: number) => {
        dispatch(setFilterEndDate(newEndDate));
    };

    const setFuzzySearch = (term: string) => {
        dispatch(setFuzzySearchTerm(term));
    };

    return {
        isShareApp,
        isToastOpen,
        filterStartTimestamp: startDate,
        filterEndTimestamp: endDate,
        fuzzySearchTerm: fuzzySearchTerm,
        openToast,
        closeToast,
        setFilterStartTimestamp: setStartDate,
        setFilterEndTimestamp: setEndDate,
        setFuzzySearchTerm: setFuzzySearch,
    };
};
